// extracted by mini-css-extract-plugin
module.exports = {"tableResult":"style_tableResult__aTZMD"};